var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8169 13.3148C28.7097 13.215 28.5824 13.1358 28.4422 13.0818C28.302 13.0278 28.1518 13 28 13C27.8482 13 27.698 13.0278 27.5578 13.0818C27.4176 13.1358 27.2903 13.215 27.1831 13.3148L13.3369 26.1711C13.2298 26.2708 13.145 26.389 13.0872 26.5192C13.0293 26.6494 12.9997 26.7888 13 26.9296V41.9286C13 42.2128 13.1216 42.4853 13.338 42.6862C13.5543 42.8871 13.8478 43 14.1538 43H24.5385C24.8445 43 25.138 42.8871 25.3544 42.6862C25.5707 42.4853 25.6923 42.2128 25.6923 41.9286V33.3578H30.3077V41.9286C30.3077 42.2128 30.4293 42.4853 30.6456 42.6862C30.862 42.8871 31.1555 43 31.4615 43H41.8462C42.1522 43 42.4457 42.8871 42.662 42.6862C42.8784 42.4853 43 42.2128 43 41.9286V26.9296C43.0003 26.7888 42.9707 26.6494 42.9128 26.5192C42.855 26.389 42.7702 26.2708 42.6631 26.1711L39.5385 23.272V16.216C39.5385 15.9319 39.4169 15.6593 39.2005 15.4584C38.9841 15.2575 38.6906 15.1446 38.3846 15.1446H36.0769C35.7709 15.1446 35.4774 15.2575 35.261 15.4584C35.0446 15.6593 34.9231 15.9319 34.9231 16.216V18.9865L28.8169 13.3148ZM15.3077 40.8573V27.3731L28 15.5882L40.6923 27.3731V40.8573H32.6154V32.2864C32.6154 32.0023 32.4938 31.7298 32.2774 31.5288C32.061 31.3279 31.7676 31.215 31.4615 31.215H24.5385C24.2324 31.215 23.939 31.3279 23.7226 31.5288C23.5062 31.7298 23.3846 32.0023 23.3846 32.2864V40.8573H15.3077Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.17f61fa63646949c333b2fcd3cd765aa.svg";
export { ForwardRef as ReactComponent };